import api from "api";
import { useState } from "react";

const QuoteItem = (
    {
        quoteitem, // équipement
        setObjectToReload, // initialise un équipement à recharger
    }
) => {

    const [quantity,setQuantity] = useState(quoteitem.quantity); //

    // gère la modification du nombre du matériel
    const handleClick = (sign) => {
        if (sign===+1 || (sign===-1 && quantity>1)) {
            setQuantity(quantity+sign);
            api.put(`item/update/${quoteitem.id}`, {
                item : quoteitem.item.id,
                quote : quoteitem.quote,
                quantity : quantity+sign
            })
            .then(()=>{
                setObjectToReload(quoteitem.item);
            });
        }
    };

    // gère l'effacement de la ligne
    const handleDel = () => {
        // eslint-disable-next-line no-restricted-globals
        const response = confirm(`Êtes vous sûr de supprime ${quoteitem.item.name}`);
        if (response) {
            api.delete(`item/delete/${quoteitem.id}`)
            .then(()=>{
                setObjectToReload(quoteitem.item);
            });
        }
    };

    return (
        <div
            className={`
                QuoteItem 
                ${quoteitem.shortage && "QuoteItemShortage"}
            `}
        >
            <div>
                {quoteitem.item.desc}
            </div>
            <div
                className="QuoteItemButton QuoteItemButtonArrow"
                onClick={()=>handleClick(-1)}
            >
                ▼
            </div>
            <div
                className="QuoteItemQuantity"
            >
                {quantity}
            </div>
            <div
                className="QuoteItemButton QuoteItemButtonArrow"
                onClick={()=>handleClick(+1)}
            >
                ▲   
            </div>
            <div
                className="QuoteItemButton"
                onClick={handleDel}
            >
                🗑️
            </div>
        </div>
    )
};

export default QuoteItem;